import React from 'react';
import { MailIcon, AtSignIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-obsidian text-white" data-id="element-84" data-mp="3gfsn6dua2wni">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" style={{
      paddingTop: "22px",
      paddingBottom: "15px"
    }} data-id="element-85" data-mp="3gh3n22klrk9c">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-aqua" data-id="element-86" data-mp="36p6aoshuym91">Sigma Smart™</p>
        <p className="mt-3 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-87" data-mp="3ufa5qbgzddof">
          Le Système Triathlon Longue Distance™
        </p>
        <p className="mt-3 text-sm font-semibold uppercase tracking-wider text-white/70" data-id="element-88" data-mp="387ejk1577e7">
          Entraînez-vous plus intelligemment. Gérez mieux votre ravitaillement. Abordez votre course avec confiance.
        </p>
        <p className="mt-2 text-sm text-white/50" data-id="element-89" data-mp="3qfjgwdb0l7mj">
          Un système pour organiser votre parcours, de l'entraînement jusqu'à la ligne d'arrivée.
        </p>

        <p className="mt-8 text-xs font-semibold uppercase tracking-wider text-white/45" data-id="element-90" data-mp="2ezb99xgq7640">Contact et assistance</p>
        <div className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/75" data-id="element-91" data-mp="3la29svmrl5vr">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-92" data-mp="3gca6l5go5xc9">
            <MailIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-93" data-mp="3q8dih31bpace" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="https://instagram.com/sigmasmart.french" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-94" data-mp="81pfbipu2x9d">
            <AtSignIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-95" data-mp="hriflnkizpyb" /> sigmasmart.french
          </a>
        </div>

        <nav aria-label="Mentions légales" className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/45" data-id="element-96" data-mp="cuiiw39kfzjv">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-97" data-mp="mrwrxht5tm25">Conditions générales</a>
          <span aria-hidden="true" data-id="element-98" data-mp="tvmqpiubmimf">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-99" data-mp="two43tyt7h7b">Politique de confidentialité</a>
          <span aria-hidden="true" data-id="element-100" data-mp="yrv16ixkpnn9">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-101" data-mp="13t0t4ejet6vq">Assistance</a>
        </nav>

        <p className="mt-8 text-xs text-white/35" data-id="element-102" data-mp="18ksmsxxv3sq3">© 2026 SIGMA SMART™ — Tous droits réservés</p>
      </div>
    </footer>;
}